import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import SingleSelector from './SingleSelector';
import MultiSelector from './MultiSelector';
import DatePicker from './DatePicker';
import RunButton from './RunButton';
import Tooltip from 'react-bootstrap/lib/Tooltip'; 
import OverlayTrigger from 'react-bootstrap/lib/OverlayTrigger';
import './bootstrap.scss';
import './app.scss';
import Slider from './Slider';

import RangeSlider from './RangeSlider';
import { computeResetValue } from './resetValue';
import { computeResetRunAction } from './resetRunAction';

let pressed = false;

class Parameter extends Component {
  constructor(props) {
    super(props);
    //get variable definition from data-variables attribute
    this.state = this.constructState();
    this.resizeTimer = null;
  }

 /**
  * This resize event is very expensive so let's do it every 250ms while resizing.
  */
  updateDimensions() {
    if (this.resizeTimer){
      clearTimeout(this.resizeTimer);
    }
    this.resizeTimer = setTimeout(() => {
      this.setState({resize:true}); //refresh UI!
    },250);
  }

  componentDidMount() {
    window.addEventListener("resize", this.updateDimensions.bind(this));
  }

  // Keep the below code for the future reference.
  //componentDidUpdate() {
  //  const paramPane = document.querySelector('.param-pane');
  //  if (paramPane && paramPane.scrollHeight > paramPane.offsetHeight && !document.body.classList.contains("with-scroll")) {
  //    document.body.classList.add("with-scroll");
  //  } else {
  //    document.body.classList.remove("with-scroll");
  //  }
  //}

  componentWillUnmount() {
    window.removeEventListener("resize", this.updateDimensions.bind(this));
  }

  /**
   * API to get translated message from parent window.
   * @param {String} key
   */
  getMessage(key) {
    if (window.parent.exploratory && window.parent.exploratory.parameter_messages) {
      return window.parent.exploratory.parameter_messages[key];
    }
    return key;
  }

  /**
   * API to get parameter hash key.
   *
   * @param   {Object}  variable  [variable description]
   * @return  {string}            [return description]
   */
  getParameterHashKey(variable) {
    const href = window.parent.location.href;
    const name = variable.name;
    return href+":"+name;
  }

  /**
   * API to check if URL contains parameter values defined in this.state.variables
   * @param  {Array}  variables  Array of variable objects
   * @return  {boolean}  Returns true if URL contains any parameter name from variables
   */
  urlContainsParameterValues(variables) {
    if (!window.parent || !window.parent.location || !variables) {
      return false;
    }
    
    try {
      const url = new URL(window.parent.location.href);
      const urlParams = new URLSearchParams(url.search);
      
      // Check if any parameter name from this.state.variables exists in URL
      for (const variable of variables) {
        if (urlParams.has(variable.name)) {
          return true;
        }
      }
    } catch (error) {
      // If URL parsing fails, return false
      return false;
    }
    
    return false;
  }

  /**
   * API to update variable with the UI change.
   * @param {Object} variable
   * @param {string|number|Array<string>|Array<number>} value - value of the parameter.
   * @param {boolean}  forceInteractive - forceInteractive overrides the ignoreInteractive.
   * The is to support enter key even on Input field even if the interactive mode checkbox is off.
   */
  onValueChange(variable, value, ignoreRun, forceInteractive) {
    variable.value = value;
    variable.isUpdated = true;
    if (window.parent) {
      const key = this.getParameterHashKey(variable);
      // remember the last selected value to local storage
      // Skip if URL contains parameter values
      if (!this.urlContainsParameterValues()) {
        const clone = JSON.parse(JSON.stringify(variable));
        clone.options = []; //clear options
        window.parent.localStorage.setItem(key, JSON.stringify(clone));
      }
    }
    if(forceInteractive || (this.state.isAutoRun && !ignoreRun)){
      this.setState({refresh:true});
      this.onClickRun({}, this.state.isDataReimport, this.state.isAutoCascading);
    } else if (this.state.isAutoCascading) { 
      this.onClickRun({}, false/*isDataReimport*/, true /*updateCascading*/); 
    } else {
      const newState = {refresh:true};
      if (value !== undefined && value !== null && value !== "" && this.state.invalidInputFields && this.state.invalidInputFields.includes(variable.name)) {
        newState.invalidInputFields = this.state.invalidInputFields.filter(name => {
          return name !== variable.name;
        });
      }
      this.setState(newState);
    }
  }

  /**
   * API to detect device type
   *
   * @return  {boolean}  [return description]
   */
  isDesktop() {
    const userAgent = navigator.userAgent;
    if (/(tablet|ipad|playbook|silk)|(android(?!.*mobi))/i.test(userAgent)) { //phone
      return false;
    }
    else if (/Mobile|Android|iP(hone|od)|IEMobile|BlackBerry|Kindle|Silk-Accelerated|(hpw|web)OS|Opera M(obi|ini)/.test(userAgent)) { //tablet
      return false;
    }
    return true;
  };

  /**
   * API to construct state from iframe.
   */
  constructState() {
    const state = {
      variables:window.frameElement && window.frameElement.getAttribute('data-variables') ? JSON.parse(window.frameElement.getAttribute('data-variables')): [],
      type: window.frameElement ? window.frameElement.getAttribute('data-type') : '',
      lang: window.frameElement ? window.frameElement.getAttribute('data-language') : '',
      isAutoRun: window.frameElement ? window.frameElement.getAttribute('data-autorun') : false,
      isAutoCascading: window.frameElement && window.frameElement.getAttribute('data-autocascading') === "true" ? true: false,
      showDownloadButton: this.isDesktop() && window.frameElement ? window.frameElement.getAttribute('data-show-download-button') === "true" : false,
      downloadDisabled: window.frameElement && window.frameElement.getAttribute('data-enable-download-button-before-query') === "true" ? false: true,
      reImportEnabled: window.frameElement && window.frameElement.getAttribute('data-reimport-enabled') === "true" ? true : false,
      isParameterRun: false,
      showUpdateChartCSVData: window.frameElement && window.frameElement.getAttribute('data-show-update-chart-csv-data-cb') === "true" ? true : false,
      showVariableApplyForAllPages: window.frameElement && window.frameElement.getAttribute('data-show-variable-apply-for-all-pages') === "true" ? true : false,
      shouldVariableApplyForAllPages: window.frameElement && window.frameElement.getAttribute('data-should-variable-apply-for-all-pages') === "true" ? true : false,
      isUpdateChartCSVData: true,
      parameterAlreadyExecuted: false,
    }
    // check previous selected value from local storage
    state.variables.forEach((variable) => {
      if (variable.isAutoRun === true) {
        state.isAutoRun = true; // if the parameter explicitly has the auto run flag, honor it. 
      } else if (variable.isAutoRun === false) {
        state.isAutoRun = false; // if the parameter explicitly has the auto run flag, honor it.
      }
      if (variable.isAutoCascading === true) {
        state.isAutoCascading = true; // if the parameter explicitly has the auto cascading flag, honor it.
      } else if (variable.isAutoCascading === false) {
        state.isAutoCascading = false; // if the parameter explicitly has the auto cascading flag, honor it.
      }
      if (variable.updateChartCsvData === true) {
        state.isUpdateChartCSVData = true; // if the parameter explicitly has the update chart csv data flag, honor it.
      } else if (variable.updateChartCsvData === false) {
        state.isUpdateChartCSVData = false; // if the parameter explicitly has the update chart csv data flag, honor it.
      }
      // restore the ui state of the shouldVariableApplyForAllPages checkbox.
      if (variable.shouldVariableApplyForAllPages !== undefined) {
        state.shouldVariableApplyForAllPages = variable.shouldVariableApplyForAllPages; // if the parameter has the update active tab only flag, honor it.
      }
      if (window.parent.exploratory && window.parent.exploratory.ia) {
        // restore sorted options.
        let sortedOptions = window.parent.exploratory.ia.getVariableSortedOptions(variable.name);
        if (sortedOptions) {
          // Multi Selector widget checks _options attribute.
          const values = variable.options.map((option) => {return option.value + "" /* convert to string */});
          // remove no longer available options.
          sortedOptions = sortedOptions.filter((sortedOption)=>{
             return values.includes(sortedOption.value+"");
          });
          // add back missing options.
          variable.options.forEach(variableOption => {
            if (!sortedOptions.find(option => {return option.value+"" === variableOption.value+""})) {
              sortedOptions.push(JSON.parse(JSON.stringify(variableOption)));
            }
          });
          variable._options = sortedOptions;
        }
        if (window.parent.exploratory.ia.isDataRefreshed) {
          state.downloadDisabled = false;
        }
      }
      const key = this.getParameterHashKey(variable);
      const _previousVariableStr = window.parent.localStorage.getItem(key);
      const isURLContainsParameterValues = this.urlContainsParameterValues(state.variables);
      const _previousVariable = !isURLContainsParameterValues && _previousVariableStr ? JSON.parse(_previousVariableStr) : null;
      if (_previousVariable && _previousVariable.type === variable.type && _previousVariable.input === variable.input && _previousVariable.multivalued === variable.multivalued) {
        if(_previousVariable.input === "lov") { // for LOV, make sure value is in the options.
          const availableValues = variable.options.map(option => {
            return option.value + ""; // convert to string
          });
          if (_previousVariable.multivalued) { // for multi LOV
            const valuesToBeRestored = _previousVariable.value.filter(value => {
              return availableValues.includes(value);
            });
            variable.value = valuesToBeRestored;
            if (!variable._options) {
              const availableValues = [];
              const selectedValues = [];
              variable.options.forEach((option) => {
                // convert displayName, name, and value to string.
                option.displayName = option.displayName !== undefined && option.displayName !== null ? (option.displayName + "") : "";
                option.name = option.name !== undefined && option.name !== null ? (option.name + "") : "";
                option.value = option.value !== undefined && option.name !== null ? (option.value + "") : "";
                const item = {
                  "name": option.displayName || option.name, 
                  "value": option.value || option.name, 
                  "canRemove": option.canRemove === true
                }
                if (Array.isArray(variable.value) && variable.value.includes(option.value)) {
                  selectedValues.push(item);
                } else {
                  availableValues.push(item);
                }
              });  
              // restore _options
              variable._options = selectedValues.concat(availableValues);
            }
            //variable.isUpdated = true;
          } else if (availableValues.includes(_previousVariable.value)) { // for single LOV
            variable.value = _previousVariable.value;
            variable.isUpdated = true;
          }
        } else { // for non LOV
          variable.value = _previousVariable.value;
          variable.isUpdated = true;
        }
      } else if (_previousVariable){
        window.parent.localStorage.removeItem(key); // clear the no longer exists parameter on the local storage.
      }
      // remember the original value for the variable.
      if (variable._originalValue !== undefined) {
         window.parent.localStorage.setItem(key+":originalVal", JSON.stringify(variable._originalValue));
      }
    });
    return state;
  }

  reRender() {
    const variables = window.frameElement && window.frameElement.getAttribute('data-variables') ? JSON.parse(window.frameElement.getAttribute('data-variables')): [];
    const variableMap = {};
    variables.forEach((variable) => {
      variableMap[variable.name] = variable.value;
    });
    const state = this.constructState();
    // make sure to uptake the values set by the user.
    state.variables.forEach((variable) => {
      if (variableMap[variable.name] !== undefined) {
        variable.value = variableMap[variable.name];
      }
    });
    this.setState(state);
  }

  /**
   * API to render Selector widget
   * @param {Object} variable
   */
  renderSelector(variable) {
    let defaultValue = {};
    let options = variable.options;
    // for logical make sure to show TRUE/FALSE
    if(variable.type === "logical" &&  (!options || options.length === 0 )) {
      options = [{value:'TRUE',displayName:'TRUE'},{value: 'FALSE', displayName:'FALSE'}];
      variable.options = options;
    }
    // Check if options are still undefined after logical type handling
    if (!options || !Array.isArray(options)) {
      return this.renderIncompleteParameter(variable);
    }
    const items = options.map(option => {
      const item = {value: option.value, label: option.displayName};
      if(option.value === variable.value) {
        defaultValue = item;
      }
      return item;
    });
    const label = this.renderLabel(variable);
    return (
      <div className={variable.disabled ? "hidden" : "form-group"}>
        {label}
        <SingleSelector
          allowAddOption={true}
          _ref={variable.name}
          name={variable.name}
          variable={variable}
          items={items}
          isClearable={false}
          showLabel={true}
          getMessage={this.getMessage}
          defaultValue={defaultValue}
          onEnterKey={this.onClickRun.bind(this)}
          placeholder={this.getMessage("dataframe.Choose...")}
          onSuggestionSelected={ (value, isPartial) => {
            this.onValueChange(variable, value);
          }}
        />
       </div>
      );
  }

  /**
   * API to render LOV widget
   * @param{Object} variable
   */
  renderLOV(variable, index) {
    // Check if options are undefined (incomplete parameter definition)
    if (!variable.options || !Array.isArray(variable.options)) {
      return this.renderIncompleteParameter(variable);
    }
    const defaultValue = [];
    variable.options.forEach(option => {
      if(variable.value.indexOf(option.value) > -1) {
        defaultValue.push(option);
      }
    });
    let label = this.getMessage("datafram.Choose...");
    if(variable.useAllValuesAsDefaultValues) {
      label = this.getMessage("dataframe.All");
    }
    const labelElement = this.renderLabel(variable);
    return (
      <div className={variable.disabled ? "hidden" : "form-group" + (variable.lovWidgetType === "list" ? " list" : "")}>
        {labelElement}
        <MultiSelector
          allowAddOption={true}
          _ref={variable.name}
          name={variable.name}
          getMessage={this.getMessage}
          variable={variable}
          clearable={true}
          honorDefaultAsIs={true}
          showLabel={true}
          index={index}
          onEnterKey={this.onClickRun.bind(this)}
          hideValue={true}
          defaultValue={defaultValue}
          placeholder={label}
          onSelectionChange={
            (variable, value) => {
              this.onValueChange(variable, value);
            }
          }/>
       </div>
    );
  }

  /**
   * API to clear local storage for specific variable.
   *
   * @param   {object}  variable  [variable description]
   * @param   {boolean} shouldRefresh  [shouldRefresh description]
   */
  clearLocalStorageVariable(variable, shouldRefresh) {
    if (window.parent) {
      const key = this.getParameterHashKey(variable);
      window.parent.localStorage.removeItem(key);
      // Restore the reset value. Delegated to a pure helper so the logic
      // (incl. the Select-All session-filter fix, tam#36243) is unit-testable.
      const storedOriginalValueRaw = window.parent.localStorage.getItem(key+":originalVal");
      variable.value = computeResetValue(variable, storedOriginalValueRaw);
      // For Slider, need to call onChange explicitly.
      if (this.refs["v-" + variable.name] && this.refs["v-" + variable.name].refs["input-range"]) {
        // If range slider, check if the value is undefined and set it to the min or max.
        if (variable.input === "range") {
          if (variable.value && Array.isArray(variable.value) && (variable.value[0] === undefined || isNaN(variable.value[0]))) {
            variable.value[0] = variable.min;
          }
          if (variable.value && Array.isArray(variable.value) && (variable.value[1] === undefined || isNaN(variable.value[1]))) {
            variable.value[1] = variable.max;
          }
        }
        if (variable.input === "range") { // for range slider
          this.refs["v-" + variable.name].refs["input-range"].props.onChange({min: variable.value[0], max: variable.value[1]});
        } else { // for single slider
          this.refs["v-" + variable.name].refs["input-range"].props.onChange(variable.value);
        }
      }
      if (shouldRefresh) {
        this.setState({refresh:true});
        // Mirror onValueChange: run on auto-run, otherwise trigger a cascading
        // parameter update when "Update Other Parameter Values" is on. tam#36882
        const action = computeResetRunAction(this.state);
        if (action === 'run') {
          this.onClickRun();
        } else if (action === 'cascade') {
          this.onClickRun({}, false/*isDataReimport*/, true/*updateCascadingParameter*/);
        }
      }
    }
  }

  /**
   * API to clear local storage for all the variable.
   *
   */
  clearLocalStorageVariables() {
    this.state.variables.forEach((variable)=>{
      this.clearLocalStorageVariable(variable, false);
    });
    this.setState({refresh:true});
    // Mirror onValueChange: run on auto-run, otherwise trigger a cascading
    // parameter update when "Update Other Parameter Values" is on. tam#36882
    const action = computeResetRunAction(this.state);
    if (action === 'run') {
      this.onClickRun();
    } else if (action === 'cascade') {
      this.onClickRun({}, false/*isDataReimport*/, true/*updateCascadingParameter*/);
    }
  }

  renderLabel(variable, options = {}) {
    let isUpdated = false;
    const key = this.getParameterHashKey(variable);
    const _originalValue = window.parent.localStorage.getItem(key + ":originalVal");
    if (_originalValue !== undefined && _originalValue !== null) {
      const originalValue = JSON.parse(_originalValue);
      if (Array.isArray(originalValue)) {
        isUpdated = JSON.stringify(originalValue) !== JSON.stringify(variable.value);
      } else {
        isUpdated = originalValue !== variable.value;
      }
    }
    const showResetIcon = options.showResetIcon !== false;
    return (
      <label>
        <div className={"variable-name"}>
          {options.showIncompleteIcon && (
            <i
              className="fal fa-exclamation-triangle"
              style={{ color: "#a94442", paddingRight: "6px", marginTop: "-3px", verticalAlign: "middle" }}
            ></i>
          )}
          {variable.displayName || variable.name}
        </div>
        {showResetIcon && (
          <OverlayTrigger trigger={"hover"} placement={"top"} overlay={<Tooltip>{this.getMessage("dataframe.Reset Value")}</Tooltip>}>        
            <i onClick={()=>{
              this.clearLocalStorageVariable(variable, true);
            }} style={{paddingLeft: "10px", "transform": "translateY(-5px)"}} className={"fal fa-sync " + (isUpdated ? "updated" : "")}></i>
          </OverlayTrigger>
        )}
        <OverlayTrigger trigger={"hover"} placement={"top"} overlay={<Tooltip className="description-tooltip">{variable.ignore ? this.getMessage("dataframe.Select Parameter") : this.getMessage('dataframe.Ignore Parameter')}</Tooltip>}>
          <i onClick={()=>{
            variable.ignore = !variable.ignore;
            variable.isUpdated = true;
            this.setState({refresh:true});
          }} style={{"paddingLeft": "10px", "transform": "translateY(-4px"}} className={"fal fa-toggle-" + (variable.ignore ? "off" : "on") + (variable.supportIgnore ? "" : " hidden")}></i>
        </OverlayTrigger>
      </label>
    );
  }

  /**
   * API to render incomplete parameter message when options are undefined
   * @param {Object} variable
   */
  renderIncompleteParameter(variable) {
    const label = this.renderLabel(variable, { showIncompleteIcon: true, showResetIcon: false });
    return (
      <div className={(variable.disabled ? "hidden" : "form-group") + (variable.ignore ? " ignore" : "")}>
        {label}
        <div className="incomplete-parameter-message" style={{color: "#a94442"}}>
          {this.getMessage("dataframe.Parameter Definition Incomplete")}
        </div>
      </div>
    );
  }

  renderCheckbox(variable) {
    return <div></div>
  }

  renderRadioButton(variable) {
    return <div></div>
  }

  /**
   * Generates functions for both onKeyUp and onKeyPress. This function
   * can detect that the enter key event happens inside or outside of
   * the IME operation and refreshes viz only for the enter key event
   * outside of the IME operation.
   *
   * The trick is, if the enter key event happens inside the IME operation,
   * it bypass the keypress event and directly go to the keyup event.
   * If it is outside the IME frame, it goes keypress, then goes to keyup.
   * Reference: https://garafu.blogspot.com/2015/09/jquery-complete.html
   */
  onKeyHandlerGenerator(variable) {
    const self = this;
    const onKeyPressHandler = function(ev) {
      // React's syntheticKeyboardEvent.keyCode returns 0 on key press. Check the native event.
      pressed = ev.nativeEvent.keyCode === 13;
    };
    const onKeyUpHandler = function(ev) {
      // Check the native event to be consistent with on key press case above.
      if (ev.nativeEvent.keyCode === 13 && pressed) {
        self.onValueChange(variable, ev.target.value, false/*ignoreRun*/, true/*forceInteractive*/);
      }
      // reset
      pressed = false;
    };
    return {
      onKeyPressHandler: onKeyPressHandler,
      onKeyUpHandler:onKeyUpHandler
    };
  }

  /**
   * API to render input field
   * @param {Object} variable
   **/
  renderInputField(variable){
    let inputField = null;
    const self = this;
    const handlers = self.onKeyHandlerGenerator(variable);
    const isInvalid = this.state.invalidInputFields && this.state.invalidInputFields.includes(variable.name);
    if(variable.type === 'numeric') {
      inputField = (
        <div>
          <div className={"form-group" + (isInvalid ? " has-feedback has-error" : "")}>
            <input type={"number"}
              ref={variable.name}
              className={"form-control"}
              min={variable.min}
              max={variable.max}
              step={variable.step}
              name={variable.name}
              onKeyUp={handlers.onKeyUpHandler}
              onKeyPress={handlers.onKeyPressHandler}
              onInput={(event) => {
                const inputField = ReactDOM.findDOMNode(self.refs[variable.name]);
                const val = event.target.value;
                const max = variable.max;
                const min = variable.min;
                if(val !== "") { // if backspace key is entered, val becomes ""
                  if (max && val > parseFloat(max)){
                    inputField.value = max;
                  } else if (min && val < parseFloat(min)){
                    inputField.value = min;
                  }
                }
              }}
              placeholder={this.getMessage("dataframe.Enter Value")}
              onChange={function(event){
                self.onValueChange(variable, event.target.value, true/*ignoreRun*/);
              }}
              value={variable.value}/>
            <i className={isInvalid ? "default-value-missing fal fa-exclamation-triangle" : "hidden"}></i>
            <span style={{marginTop: "-10px"}} className={isInvalid ? "help-block" : "hidden"}>{isInvalid ? this.getMessage("dataframe.Please Enter Value") : ""}</span>
          </div>
        </div>
      );
    } else {
      inputField = (
        <div>
          <div className={"form-group" + (isInvalid ? " has-feedback has-error" : "")}>
            <input 
              type={"text"}
              ref={variable.name}
              className={"form-control"}
              name={variable.name}
              onKeyUp={handlers.onKeyUpHandler}
              onKeyPress={handlers.onKeyPressHandler}
              placeholder={this.getMessage("dataframe.Enter Value")}
              onChange={(event) => {
                self.onValueChange(variable, event.target.value, true/*ignoreRun*/);
              }}
              value={variable.value}/>
            <i className={isInvalid ? "default-value-missing fal fa-exclamation-triangle" : "hidden"}></i>
            <span style={{marginTop: "-10px"}} className={isInvalid ? "help-block" : "hidden"}>{isInvalid ? this.getMessage("dataframe.Please Enter Value") : ""}</span>
          </div>
        </div>
      );
    }
    const label = this.renderLabel(variable);
    return (
      <div className={(variable.disabled ? "hidden" : "form-group") + (variable.ignore ? " ignore" : "")}>
        {label}
        {inputField}
      </div>
    );
  }

  renderSlider(variable){
    const label = this.renderLabel(variable);
    return (
      <div className={(variable.disabled ? "hidden" : "form-group slider") + (variable.ignore ? " ignore": "")} onMouseDown={()=>{this.enableSliderMoveEvent(variable.name)}}>
        {label}
        <Slider min={variable.min}
          ref={"v-" + variable.name}
          max={variable.max}
          step={variable.step}
          name={variable.name}
          value={variable.value}
          onChange={(value) => {
            this.onValueChange(variable, value, true/*ignoreRun*/);
          }}
          onChangeComplete={(value) => {
            this.onValueChange(variable, value);
          }}
          />
      </div>
    );
  }

  renderRangeSlider(variable) {
    const _onRangeSliderStopped = (value, ignoreInteractive) => {
      const _value = [value.min, value.max];
      this.onValueChange(variable, _value, !!ignoreInteractive);
    }
    const label = this.renderLabel(variable);
    return (
      <div className={(variable.disabled ? "hidden" : "form-group slider") + (variable.ignore ? " ignore": "")} onMouseDown={()=>{this.enableSliderMoveEvent(variable.name)}}>
        {label}
        <RangeSlider 
          min={variable.min}
          max={variable.max}
          step={variable.step}
          allowSameValue={false}
          name={variable.name}
          ref={"v-"+variable.name}
          value={variable.value}
          onChange={(value) => {
            _onRangeSliderStopped(value, true/*ignoreInteractive*/);
          }}
          onChangeComplete={(value) => {
            _onRangeSliderStopped(value);
          }}
          />
      </div>
    );
  }

  renderDatePicker(variable){
    const label = this.renderLabel(variable);
    return (
      <div className={(variable.disabled ? "hidden" : "form-group") + (variable.ignore ? " ignore": "")}>
        {label}
        <DatePicker
          locale={this.state.lang}
          defaultPlaceholder={this.getMessage("dataframe.Choose...")}
          id={Date.now()}
          dataType={"Date"}
          showToday={true}
          highlightToday={true}
          min={variable.min}
          max={variable.max}
          name={"v-" + variable.name}
          ref={"v-" + variable.name}
          value={variable.value}
          onChange={
            (value) => {
              this.onValueChange(variable, value, !value/*ignoreRun*/);
            }
          }
        />
      </div>
    );
  }

  renderDateTimePicker(variable){
    const label = this.renderLabel(variable);
    return (
      <div className={(variable.disabled ? "hidden" : "form-group") + (variable.ignore ? " ignore": "")}>
        {label}
        <DatePicker
          locale={this.state.lang}
          id={Date.now()}
          dataType={"POSIXct"}
          showToday={true}
          highlightToday={true}
          min={variable.min}
          max={variable.max}
          name={"v-" + variable.name}
          ref={"v-" + variable.name}
          value={variable.value}
          onChange={
            (value) => {
              this.onValueChange(variable, value, !value/*ignoreRun*/);
            }
          }
        />
      </div>
    );
  }

  /**
   * 
   * @param {Object} event 
   * @param {boolean} isDataReimport 
   * @param {boolean} updateCascadingParameter 
   * @returns 
   */
  onClickRun(event, isDataReimport, updateCascadingParameter) {
    if (window.parent && window.parent.exploratory) {
      const invalidInputFields = [];
      const isUpdateChartCSVData = true; //Discussed at the 9pm meeting on Jul 23 and decided to always set true. this.refs["update-chart-csv-data-cb"].checked;
      // if this is a first time execution, mark all variables as updated.
      if (!this.state.parameterAlreadyExecuted) {
        this.state.variables.forEach(function(variable){
          variable.isUpdated = true;
        });
      }
      const clonedVariables = JSON.parse(JSON.stringify(this.state.variables));
      clonedVariables.forEach((variableObj)=>{
        const defaultValue = variableObj.value;
        const widgetType = variableObj.input;
        const useEmptyAsDefaultValue = variableObj.useEmptyAsDefaultValue;
        if (widgetType === "field" && 
            useEmptyAsDefaultValue === false &&
            (defaultValue === "" || defaultValue === null || defaultValue === undefined)
        ) {
          invalidInputFields.push(variableObj.name);
        }
      });
      // if there is any invalid input field, do not run the query and show the error.
      if (invalidInputFields.length > 0) {
        this.setState({
          invalidInputFields: invalidInputFields
        });
        return;
      }
      window.parent.exploratory.ia.refreshData(
        clonedVariables, 
        this.state.showUpdateChartCSVData && isUpdateChartCSVData, 
        this.state.isAutoRun, 
        !this.state.shouldVariableApplyForAllPages,
        isDataReimport,
        updateCascadingParameter,
        this.state.isAutoCascading
      );
      this.state.variables.forEach(function(variable){
        variable.isUpdated = false;
      });
      const messageDiv = document.getElementById("rerun-parameter-message");
      if (!messageDiv.classList.contains("hidden")) {
        messageDiv.classList.add("hidden");
      }
      this.setState({downloadDisabled: false, invalidInputFields: [], parameterAlreadyExecuted: true});
    }
  }

  onClickDownload() {
    if(window.parent && window.parent.exploratory){
      window.parent.exploratory.ia.triggerDownloadData();
    }
  }

  disableSliderMoveEvent(event) {
    if (event && event.pageX > 0) {
      return; //if the mouse is released inside container, do not disable slider.
    }
    // it means the mouse position is out side of the parameter panel.
    // so need to take care of the auto run case explicitly.
    setTimeout(() => {
      if (this.state.isAutoRun) {
        let hasActiveSlider = false;
        this.state.variables.some(variable =>{
          const ref = this.refs["v-"+ variable.name];
          if (ref && ref.refs && ref.refs["input-range"]) {
            const inputRange = ref.refs["input-range"];
            // if the mouse is moved outside of the slider container, disable the slider move event.
            if (!inputRange.props.disabled) {
              hasActiveSlider = true;
              return true;
            }
            return false;
          }
          return false;
        });
        if (hasActiveSlider) {
          this.onClickRun();
        }
      }
      this.state.variables.some(variable =>{
        const ref = this.refs["v-"+ variable.name];
        if (ref && ref.refs && ref.refs["input-range"]) {
          const inputRange = ref.refs["input-range"];
          // if the mouse is moved outside of the slider container, disable the slider move event.
          if (!inputRange.props.disabled) {
            inputRange.props.disabled = true;
          }
        }
      });
    },100);
  }

  enableSliderMoveEvent(name) {
    if (this.refs && this.refs["v-" + name]) {
      const ref = this.refs["v-" + name] && this.refs["v-" + name].refs["input-range"] ? this.refs["v-" + name].refs["input-range"] : this.refs["v-" + name];
      // if the slider is disabled, it means it was disabled since mouse was dragged outside of the container.
      // since now it's clicked again, enable the slider move event.
      if (ref && ref.props.disabled) {
        ref.props.disabled = false;
      }
    }
  }

  getPredefinedDateOptionsDisplayName(option) {
    let label = option;
    switch(option) {
      case "today": {
        label= this.getMessage("dataframe.Today");
        break;
      }
      case "last_7_days": {
        label = this.getMessage("dataframe.Last 7 Days");
        break;
      }
      case "last_4_weeks": {
        label = this.getMessage("dataframe.Last 4 Weeks");
        break;
      }
      case "last_3_months": {
        label = this.getMessage("dataframe.Last 3 Months");
        break;
      }
      case "last_12_months": {
        label = this.getMessage("dataframe.Last 12 Months");
        break;
      }
      case "month_to_date": {
        label = this.getMessage("dataframe.Month to Date");
        break;
      }
      case "quarter_to_date": {
        label = this.getMessage("dataframe.Quarter to Date");
        break;
      }
      case "year_to_date": {
        label = this.getMessage("dataframe.Year to Date");
        break;
      }
      case "all": {
        label = this.getMessage("dataframe.All Time");
        break;
      }
    }
    return label;
  }

  renderPredefinedDateSelector(variable) {
    let defaultValue = {};
    const options = [
      {
        value: "today",
        displayName: this.getPredefinedDateOptionsDisplayName("today")
      },
      {
        value: "last_7_days",
        displayName: this.getPredefinedDateOptionsDisplayName("last_7_days")
      },
      {
        value: "last_4_weeks",
        displayName: this.getPredefinedDateOptionsDisplayName("last_4_weeks")
      },
      {
        value: "last_3_months",
        displayName: this.getPredefinedDateOptionsDisplayName("last_3_months")
      },
      {
        value: "last_12_months",
        displayName: this.getPredefinedDateOptionsDisplayName("last_12_months")
      },
      {
        value: "month_to_date",
        displayName: this.getPredefinedDateOptionsDisplayName("month_to_date")
      },
      {
        value: "quarter_to_date",
        displayName: this.getPredefinedDateOptionsDisplayName("quarter_to_date")
      },
      {
        value: "year_to_date",
        displayName: this.getPredefinedDateOptionsDisplayName("year_to_date")
      },
      {
        value: "all",
        displayName: this.getPredefinedDateOptionsDisplayName("all")
      }            
    ];
    variable.options = options;
    const items = options.map(option => {
      const item = {value: option.value, label: option.label};
      if(option.value === variable.value) {
        defaultValue = item;
      }
      return item;
    });
    const label = this.renderLabel(variable);
    return (
      <div className={variable.disabled ? "hidden" : "form-group"}>
        {label}
        <SingleSelector
          allowAddOption={true}
          _ref={variable.name}
          name={variable.name}
          variable={variable}
          items={items}
          isClearable={false}
          showLabel={true}
          getMessage={this.getMessage}
          defaultValue={defaultValue}
          onEnterKey={this.onClickRun.bind(this)}
          placeholder={this.getMessage("dataframe.Choose...")}
          onSuggestionSelected={ (value, isPartial) => {
            this.onValueChange(variable, value);
          }}
        />
      </div>
    );
  }

  /**
   * main rendering API
   */
  render() {
    const paramFields = this.state.variables.map((variable, index) => {
       switch(variable.type) {
         case 'character':
          switch(variable.input) {
            case 'lov':
              if(variable.multivalued) {
                return this.renderLOV(variable, index);
              }
              return this.renderSelector(variable);
            case 'checkbox':
              return this.renderCheckbox(variable);
            case 'radio':
              return this.renderRadioButton(variable);
            default:
              return this.renderInputField(variable);
          }
        case 'numeric':
          switch(variable.input) {
            case 'lov':
              if(variable.multivalued) {
                return this.renderLOV(variable, index);
              }
              return this.renderSelector(variable);
            case 'slider':
              return this.renderSlider(variable);
            case 'range':
              return this.renderRangeSlider(variable);
            default:
              return this.renderInputField(variable);
          }
        case 'logical':
          if(variable.multivalued) {
            return this.renderLOV(variable, index);
          }
          return this.renderSelector(variable);
        case 'Date':
          if (variable.optionsType === "predefined") {
            return this.renderPredefinedDateSelector(variable);
          }
          return this.renderDatePicker(variable);
        case 'POSIXct':
          if (variable.optionsType === "predefined") {
            return this.renderPredefinedDateSelector(variable);
          }
          return this.renderDateTimePicker(variable);
       }
    });
    const downloadButton = (
      <button onClick={(/*event*/) => {this.onClickDownload()}}
        disabled={this.state.downloadDisabled}
        className={"ia-download-data-btn btn btn-default" + (this.state.downloadDisabled ? " disabled" : "")}>{this.getMessage("dataframe.Download Data")}
      </button>
    );

    const height = window.innerHeight;
    let extraClass = "";
    if (navigator.userAgent.indexOf('Safari') !== -1 && navigator.userAgent.indexOf('Chrome') === -1) {
      extraClass = ' safari';
    }
    const isNoParameter = !this.state.variables || this.state.variables.length === 0;

    return (
      <div className={"param-pane" + extraClass} style={{"height": height + "px"}} onMouseLeave={(event)=>{this.disableSliderMoveEvent(event)}}>
        <div className={"reset-default-values" + (isNoParameter ? " hidden" : "")}>
          <i className="fal fa-sync"></i>
          <a href="javascript:void(0)" onClick={this.clearLocalStorageVariables.bind(this)}>{this.getMessage("dataframe.Set Default Values")}</a>
        </div>
        {paramFields}
        <div className="horizontal-separator"></div>
        <RunButton 
          reImportEnabled={false /*this.state.reImportEnabled*/} 
          getMessage={this.getMessage.bind(this)} 
          onClickRun={this.onClickRun.bind(this)} 
          onlyShowReImport={isNoParameter} 
          onSelectCallback={(isReimport)=>{this.setState({isDataReimport: isReimport})}}
          onReImportThenRun={(e)=>{this.onClickRun(e, true)}}
        />
        <button id={"re-render-param-button"} onClick={this.reRender.bind(this)} className="hidden"></button>
        <div className={"ia-auto-run-container" + (isNoParameter ? " hidden" : "")} >
          <input className="ia-auto-run"
            type="checkbox"
            id={"auto-run-checkbox"}
            checked={this.state.isAutoRun ? "checked" : undefined}
            onClick={ (event) => {
              this.setState({isAutoRun: event.target.checked});
            }}/>
          <div onClick={()=>{
            const checkbox = document.getElementById("auto-run-checkbox");
            if (checkbox) {
              checkbox.click();
            }
          }} className="ia-auto-run-label">{this.getMessage("dataframe.Auto Run")}</div>
        </div>
        <div className={(this.state.showVariableApplyForAllPages && !isNoParameter) ? "ia-auto-run-container" : "hidden"}>
          <input className="ia-auto-run"
            type="checkbox"
            ref="should-variable-update-only-active-tab"
            checked={this.state.shouldVariableApplyForAllPages ? "checked" : undefined}
            id={"should-variable-update-only-active-tab-checkbox"}
            onClick={ (event) => {
              this.setState({shouldVariableApplyForAllPages: event.target.checked});
            }}/>
          <div onClick={()=>{
            const checkbox = document.getElementById("should-variable-update-only-active-tab-checkbox");
            if (checkbox) {
              checkbox.click();
            }
          }} className="ia-auto-run-label">{this.getMessage("dataframe.Apply for All Pages")}</div>
        </div>
        <div className={"hidden"}>
          <input className="ia-auto-run"
            type="checkbox"
            ref="update-chart-csv-data-cb"
            checked={"checked"}
            id={"update-csv-data-checkbox"}
            onClick={ (event) => {
              this.setState({isUpdateChartCSVData: event.target.checked});
            }}/>
          <div onClick={()=>{
            const checkbox = document.getElementById("update-csv-data-checkbox");
            if (checkbox) {
              checkbox.click();
            }
          }} className="ia-auto-run-label">{this.getMessage("dataframe.Update Chart CSV Data")}</div>
        </div>
        <div className={isNoParameter ? "hidden" : "ia-auto-run-container"}>
          <input className="ia-auto-run"
            type="checkbox"
            ref="auto-cascading-checkbox"
            id={"auto-cascading-checkbox"}
            checked={this.state.isAutoCascading ? "checked" : undefined}
            onClick={ (event) => {
              this.setState({isAutoCascading: event.target.checked});
            }}/>
          <div onClick={()=>{
            const checkbox = document.getElementById("auto-cascading-checkbox");
            if (checkbox) {
              checkbox.click();
            }
          }} className="ia-auto-run-label">{this.getMessage("dataframe.Update Other Parameter Values")}</div>
          <OverlayTrigger trigger="hover" placement="top" overlay={<Tooltip id="auto-cascading-tooltip">{this.getMessage("dataframe.Auto Cascading Tooltip")}</Tooltip>}>
            <i className="fal fa-info-circle" style={{marginLeft: "10px"}}></i>
          </OverlayTrigger>
        </div>
        {this.state.showDownloadButton ? downloadButton : ""}
        <div className={"hidden" /* Decided to hide this all the time for now. 1/21/2025 */} id={"rerun-parameter-message"} style={{marginTop: "30px", color: "#808080"}}>{this.getMessage("dataframe.Rerun Parameter To Update")}</div>
      </div>
    );
  }
};
export default Parameter;
